import { create_trigger } from '@/base/trigger'
export default {
  'lock': false,
  'hidden': false,
  'style': {
    // 'width': 180,
    'font-size': 14,
    'line-height': 18,
    'letter-spacing': 0,
    'font-family': 'font-25',
    // 'color': '#666666',
    'position': 'absolute',
    'left': 0,
    'top': 0,
    'rotate': 0,
    'height': 'auto',
    'transform': 'rotate(0deg)',
    width: 130,
    color: '#000',
    background: 'transparent',
    'text-align': 'left',
    'text-decoration': 'none',
    'font-weight': 'normal',
    'font-style': 'normal'
  },
  'text': '请双击输入文字',
  'link': null,
  'textType': 'text',
  'imageLink': '',
  'mask': false,
  'cmpType': 'text',
  'type': 'basic_text',
  'name': ''
}
